import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'xland-ui';
import SectionHeader from 'components/SectionHeader';
import ServicesTab from './ServicesTab';
import RequestTab from './RequestTab';
import './styles.scss';

function Services(props) {
  const { literals } = props;
  const tabs = [
    { key: 'services', name: literals.title },
    { key: 'requests', name: literals.requests },
  ];

  return (
    <>
      <Breadcrumb routes={[{ name: literals.title }]} />
      <SectionHeader tabs={tabs}>
        { tab => (
          <>
            { tab === 'services' && <ServicesTab {...props} /> }
            { tab === 'requests' && <RequestTab {...props} /> }
          </>
        )}

      </SectionHeader>
    </>
  );
}

Services.propTypes = {
  literalsCommon: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
};

export default Services;
